<template>
  <v-form ref="filterForm" @submit.prevent="submitFilter()" class="filter">
    <v-row dense>
      <v-col cols="12" md="1" class="mx-md-6 mx-lg-0">
        <div
          class="d-flex align-baseline"
          :class="!$vuetify.breakpoint.xsOnly ? 'justify-space-around' : 'mb-6'"
        >
          <div class="mx-md-1 mx-lg-2 mr-2">
            <span>{{ $t("filters") }}</span>
          </div>
          <div class="flex-grow-1 mr-2">
            <v-btn
              outlined
              color="#6A6E7B"
              block
              class="btn--width40"
              :disabled="!cptdTotalFilters"
              @click="clearFilterForm()"
            >
              <v-badge
                color="red"
                overlap
                bottom
                :value="cptdTotalFilters"
                :content="cptdTotalFilters"
              >
                <v-icon> mdi-filter </v-icon>
              </v-badge>
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <v-text-field
          v-model="filters.SALES_ORDER"
          :label="$t('orderNumber')"
          outlined
          dense
          clearable
          @click:clear="clearField('SALES_ORDER')"
        />
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <v-text-field
            v-model="filters.CUSTOMER_PO"
            :label="$t('purchaseOrder')"
            outlined
            dense
            clearable
            @click:clear="clearField('CUSTOMER_PO')"
        />
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <input-date
          v-model="filters[initialDateKey]"
          :label="$t('initialDate')"
          :rules="[]"
          readonly
          @click:clear="clearField(initialDateKey)"
          dense
        />
      </v-col>
      <v-col cols="12" md="2" lg="1">
        <input-date
          v-model="filters[finalDateKey]"
          :label="$t('finalDate')"
          :rules="[dateMustBeBiggerRule]"
          readonly
          dense
          @click:clear="clearField(finalDateKey)"
        />
      </v-col>
      <v-col cols="12" md="2">
        <autocomplete-line
          v-model="filters.DESC_LINE"
          :label="$t('line')"
          outlined
          @click:clear="clearField('DESC_LINE')"
          dense
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="filters.PRODUCTPROP"
          :label="$t('product')"
          outlined
          dense
          @click:clear="clearField('PRODUCTPROP')"
          clearable
        />
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          depressed
          color="#D8D8D8"
          :block="$vuetify.breakpoint.xsOnly"
          type="submit"
        >
          <v-icon> mdi-magnify </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="1">
        <v-btn
          depressed
          color="#D8D8D8"
          @click="downloadOrders()"
          :disabled="this.disabled"
        >
          <v-icon
          color="green"
          > 
          mdi-file-excel-box 
        </v-icon>
          Excel
        </v-btn>
      </v-col>
    </v-row>
    <v-divider />
    <TLoading v-model="loading" />
  </v-form>
</template>

<script>
import mixinFilters from "@/mixins/mixinFilter";
import InputDate from "@/arch/components/InputDate";
import AutocompleteLine from "@/components/AutocompleteLine.vue";

export default {
  name: "DefaultFiltersComponent",
  mixins: [mixinFilters],
  components: {
    InputDate,
    AutocompleteLine,
  },
  methods: {
    clearClicked() {
      console.log('lol')
    }
  },
  data() {
    return {
      path: "",
      months: [],
      initialDateKey: "ORDER_DATE_INICIAL",
      finalDateKey: "ORDER_DATE_FINAL",
      filters: {
        SALES_ORDER: "",
        CUSTOMER_PO: "",
        DESCRIPTION: "",
        DESC_LINE: "",
        ITEM: "",
        PRODUCTPROP: "",
        STATUS:""
      },
    };
  },
};
</script>
